import React from 'react';

import { useBooleanState } from '@lumapps/lumx-hooks/hooks/useBooleanState';
import { useLazyLoadingProgress } from '@lumapps/lumx-suspense/hooks/useLazyLoadingProgress';

export function useLoadTeamsShareDialog() {
    const [isShareToTeamsDialog, openShareToTeamsDialog, closeShareToTeamsDialog] = useBooleanState(false);
    const [teamsIsLoaded, setTeamsIsLoaded] = React.useState(false);
    const { onComponentLoaded: onTeamsLoaded } = useLazyLoadingProgress(teamsIsLoaded);
    const handleOpenTeams = React.useCallback(() => {
        setTeamsIsLoaded(true);
        openShareToTeamsDialog();
    }, [openShareToTeamsDialog]);
    return {
        teamsIsLoaded,
        onTeamsLoaded,
        handleOpenTeams,
        isShareToTeamsDialog,
        openShareToTeamsDialog,
        closeShareToTeamsDialog,
    };
}
